export const getMobileMaxColumnWidth = (minimumColumnCount) => {
    if (typeof window === 'undefined') {
        return 100
    }

    return Math.floor(window.innerWidth / minimumColumnCount)
}

export const adaptiveFontSize =
    (bounds: any = {}) =>
    (data) => {
        const { upperBound = Infinity, lowerBound = 0, fixed } = bounds
        const {
            parent: { fontSizeMinimum },
            gridPadding,
            columnWidth,
            columnCount,
            config,
            chain,
        } = data
        const [parentOfParent] = chain
        const {
            column: { maxWidth },
        } = parentOfParent
        const minWidth = fixed
            ? columnWidth
            : columnCount > 1
              ? (maxWidth * (columnCount - 1)) / columnCount
              : maxWidth

        const ratio = fontSizeMinimum / minWidth
        const { px } = config
        const rounded =
            Math.round(ratio * (columnWidth - gridPadding) * 10) / 10
        const result = Math.min(Math.max(rounded, lowerBound), upperBound)

        if (px) {
            return result + 'px'
        }

        return result
    }
